<template>
  <p>
    {{ text('context_info.ARENA_LOBBY.p1') }}
  </p>
  <p>
    {{ text('context_info.ARENA_LOBBY.p2') }}
  </p>
  <hr />
  <div class="mt-3">
    <span class="text-green-400">***{{ text('context_info.coming_soon') }}*** </span>
    <ul class="px-10 list-outside list-disc">
      <li>{{ text('context_info.ARENA_LOBBY.coming_soon_1') }}</li>
      <li>{{ text('context_info.ARENA_LOBBY.coming_soon_2') }}</li>
      <li>{{ text('context_info.ARENA_LOBBY.coming_soon_3') }}</li>
    </ul>
  </div>
</template>

<script setup>
import text from '~/text';
</script>